export function isProductionDiscoveryFilterEnabled(): boolean {
  return process.env.NODE_ENV === 'production'
}

export function isIntelligenceDiscoveryItem(item: any): boolean {
  if (!item || typeof item !== 'object') {
    return false
  }

  if (item.is_intelligence_report === true || item.isIntelligenceReport === true) {
    return true
  }

  if (item.intelligence_report_id || item.intelligenceReportId || item.report_id || item.reportId) {
    return true
  }

  const id = typeof item.id === 'string' ? item.id : ''
  if (id.startsWith('ia-')) {
    return true
  }

  const model = String(item.model_used || item.model || '').trim().toLowerCase()
  if (model === 'intelligence') {
    return true
  }

  const reportType = String(item.report_type || item.reportType || '').trim().toLowerCase()
  return reportType === 'intelligence'
}

export function filterProductionDiscoveryItems<T>(items: T[]): T[] {
  if (!Array.isArray(items)) {
    return []
  }

  if (!isProductionDiscoveryFilterEnabled()) {
    return items
  }

  return items.filter((item) => isIntelligenceDiscoveryItem(item))
}
